<template>
  <router-view />
</template>

<script setup>
import { watchEffect } from 'vue';
import { ui } from '@/stores/ui';

// Marca el body cuando la barra está cerrada, para que el contenido reflua.
watchEffect(() => {
  if (typeof document !== 'undefined') {
    document.body.classList.toggle('sidebar-collapsed', !ui.sidebarOpen);
  }
});
</script>

<style>
/* Transición fluida del contenido al abrir/cerrar la barra (solo escritorio,
   donde el contenido tiene margen para la barra fija). */
@media (min-width: 992px) {
  .main-content {
    transition: margin-left .3s ease;
  }

  body.sidebar-collapsed .main-content {
    margin-left: 0 !important;
  }
}
</style>
